import { ProgressBar } from 'react-bootstrap';

const CustomProgressBar = ({ progress}) => {
  const customStyle = {
    height: '16px',
    backgroundColor: '#edf2f7',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)',
    border: 'none'
  };
  return (
    <div className="custom-progress-container">
      <ProgressBar
        now={progress}
        variant="success"
        style={customStyle}
        className="modern-progress"
      />
    </div>
  );
};

export default CustomProgressBar;